// extracted by mini-css-extract-plugin
module.exports = {"root":"dd31006766--root--Xp4vl","index":"dd31006766--index--ilOgU","text":"dd31006766--text--t4PGx","mobile":"dd31006766--mobile--lggKM"};